/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type CertonaItem, type CertonaPricing } from '@/types';
import { type SkuAvailabilty } from '@/types/availability';

type AvailableCertonaProductsProps = {
  items?: CertonaItem[];
  skuDetailsData?: SkuAvailabilty[] | null;
  pricingInfo?: Record<string, CertonaPricing>;
  thresholdHeaderText?: string;
  filterByPriceOnly?: boolean;
};

export const getAvailableCertonaProducts = (props: AvailableCertonaProductsProps) => {
  const { items, skuDetailsData, pricingInfo, thresholdHeaderText, filterByPriceOnly } = props;
  const availableProducts = items?.reduce<CertonaItem[]>((acc, item) => {
    const isAvailable = filterByPriceOnly
      ? // Customizable sku's products with no price should be still shown inside the certona container
        pricingInfo?.[item.id]?.configurableSku || !!pricingInfo?.[item.id]?.totalPrice
      : skuDetailsData?.some((skudata) => {
          //thresold recommendations container should only show available STH home products,Items which are only available for Same day delivery should not be included in the container
          const productAvailibility = thresholdHeaderText
            ? skudata.availabilityInfoVO.sthQuantity > 0
            : skudata.availabilityInfoVO.bopusQuantity > 0 ||
              skudata.availabilityInfoVO.sthQuantity > 0;
          // Customizable sku's products with no price should be still shown inside the certona container
          const pricingAvailability = pricingInfo?.[item.id]?.configurableSku
            ? skudata.skuId === item.id && productAvailibility
            : !!pricingInfo?.[item.id]?.totalPrice &&
              productAvailibility &&
              skudata.skuId === item.id;
          if (pricingAvailability) {
            return skudata;
          }
        });

    if (isAvailable) {
      acc = [...acc, item];
    }
    return acc;
  }, []);

  return availableProducts;
};
